import { StatusLED } from "@/components/infra";

const ITEMS = [
  { id: "members", label: "Members", value: "growing" },
  { id: "ideas", label: "Ideas", value: "unlimited" },
  { id: "location", label: "Location", value: "Global" },
  { id: "projects", label: "Projects", value: "Earth + Space" },
  { id: "possibilities", label: "Possibilities", value: "endless" },
];

export const HeroTelemetry = () => (
  <dl data-testid="hero-telemetry-strip" className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-x-5 gap-y-4 border-y hairline py-4">
    {ITEMS.map(({ id, label, value }) => (
      <div key={id} data-testid={`hero-telemetry-${id}`} className="min-w-0">
        <dt className="font-mono-label text-[9px] !tracking-normal uppercase text-[#71747B] mb-1">{label}</dt>
        <dd data-testid={`hero-telemetry-value-${id}`} className="font-mono-label text-[11px] !tracking-normal text-[#0F1117] flex items-center gap-2">{id === "members" && <StatusLED color="#10B981" />}{value}</dd>
      </div>
    ))}
  </dl>
);